import { CalendarPickerView } from '@mui/x-date-pickers';
import { getPickersLocalization } from './utils/getPickersLocalization';

const plPLPickers = {
  // Calendar navigation
  previousMonth: 'Poprzedni miesiąc',
  nextMonth: 'Następny miesiąc',

  // View navigation
  openPreviousView: 'otwórz poprzedni widok',
  openNextView: 'otwórz następny widok',
  calendarViewSwitchingButtonAriaLabel: (view: CalendarPickerView) =>
    view === 'year'
      ? 'widok roku jest otwarty, przejdź do widoku kalendarza'
      : 'widok kalendarza jest otwarty, przejdź do widoku roku',
  inputModeToggleButtonAriaLabel: (isKeyboardInputOpen: boolean, viewType: 'calendar' | 'clock') =>
    isKeyboardInputOpen
      ? `pole tekstowe jest otwarte, przejdź do widoku: ${viewType}`
      : `widok ${viewType} jest otwarty, przejdź do pola tekstowego`,

  // DateRange placeholders
  start: 'Początek',
  end: 'Koniec',

  // Action bar
  cancelButtonLabel: 'Anuluj',
  clearButtonLabel: 'Wyczyść',
  okButtonLabel: 'OK',
  todayButtonLabel: 'Dzisiaj',

  // Toolbar titles
  datePickerDefaultToolbarTitle: 'Wybierz datę',
  dateTimePickerDefaultToolbarTitle: 'Wybierz datę i godzinę',
  timePickerDefaultToolbarTitle: 'Wybierz godzinę',
  dateRangePickerDefaultToolbarTitle: 'Wybierz zakres dat',

  // Clock labels
  clockLabelText: (view: any, time: any, adapter: any) =>
    `Wybierz ${view}. ${
      time === null ? 'Nie wybrano godziny' : `Wybrana godzina: ${adapter.format(time, 'fullTime')}`
    }`,
  hoursClockNumberText: (hours: any) => `${hours} godzin`,
  minutesClockNumberText: (minutes: any) => `${minutes} minut`,
  secondsClockNumberText: (seconds: any) => `${seconds} sekund`,

  // Open picker labels
  openDatePickerDialogue: (value: any, utils: any) =>
    value !== null && utils.isValid(value)
      ? `Wybierz datę, wybrana data: ${utils.format(value, 'fullDate')}`
      : 'Wybierz datę',
  openTimePickerDialogue: (value: any, utils: any) =>
    value !== null && utils.isValid(value)
      ? `Wybierz godzinę, wybrana godzina: ${utils.format(value, 'fullTime')}`
      : 'Wybierz godzinę',

  // Table labels
  timeTableLabel: 'wybierz godzinę',
  dateTableLabel: 'wybierz datę',
};

export const plPL = getPickersLocalization(plPLPickers);